import { render, staticRenderFns } from "./control-checkbox-group.vue?vue&type=template&id=473a6586"
import script from "./control-checkbox-group.vue?vue&type=script&lang=js"
export * from "./control-checkbox-group.vue?vue&type=script&lang=js"
import style0 from "./control-checkbox-group.vue?vue&type=style&index=0&id=473a6586&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports